import { render, staticRenderFns } from "./VueRouter.vue?vue&type=template&id=480cbad1&"
import script from "./VueRouter.vue?vue&type=script&lang=js&"
export * from "./VueRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports